import { JsonRestApiRequestConfig, makeJsonRestApiRequest } from '~src/httpClient/RestApiService';

import { IConnectedApplicationType } from '../types/ConnectedApplicationType';
import { API_VERSION, EAS_PATH } from './RestApiConstants';


function UpdateConnectedApplicationConfig(id: string): JsonRestApiRequestConfig {
  return {
    restApiVersion: `${API_VERSION}`,
    httpMethod: 'PUT',
    endpoint: `${EAS_PATH}/${id}`,
    serverWideRequest: false
  };
}

// Backend is the source of truth for when things are created, not us
export type UpdateConnectedApplicationEasType = Omit<IConnectedApplicationType, 'createdAt' | 'clientId'>;
export interface UpdateEasConnectedApplicationParams {
  externalAuthorizationServer: UpdateConnectedApplicationEasType;
}

export interface UpdateEasConnectedApplicationResult {
  externalAuthorizationServer: UpdateConnectedApplicationEasType;
}

export interface UpdateEasConnectedApplicationError {
  summary: string;
  detail: string;
  code: string;
}

export function callUpdateConnectedApplicationEas(request: UpdateEasConnectedApplicationParams): Promise<UpdateEasConnectedApplicationResult> {
  return makeJsonRestApiRequest<UpdateEasConnectedApplicationParams, UpdateEasConnectedApplicationResult>({
    config: UpdateConnectedApplicationConfig(request.externalAuthorizationServer.id),
    request,
  });
}